import React, { useState, useEffect } from "react";
import styled from "styled-components";

const Bar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #2c2c2c;
  color: #fff;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  z-index: 1000;
`;

const Button = styled.button`
  background: #ff9800;
  border: none;
  padding: 8px 16px;
  margin-left: 12px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  color: #fff;

  &:hover {
    background: #e68900;
  }
`;

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Bar>
      <span style={{ color: "#AAAAAA" }}>
        We use cookies to improve your experience. By using Tellerpoint, you
        agree to our{" "}
        <a
          href="/cookie-policy.html"
          style={{ color: "#ff9800", textDecoration: "underline" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          Cookie Policy
        </a>
        .
      </span>
      <Button onClick={handleAccept}>Accept</Button>
    </Bar>
  );
};

export default CookieConsent;
